import { formatDistanceToNow, format } from "date-fns";

export const CURRENCY_SYMBOL = { USD: "$", NGN: "₦" };

export function formatCurrency(amount, currency = "USD") {
  const sym = CURRENCY_SYMBOL[currency] || "";
  const n = Number(amount || 0);
  return `${sym}${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(dateStr) {
  try {
    return format(new Date(dateStr), "MMM d, yyyy");
  } catch {
    return dateStr;
  }
}

export function relativeTime(iso) {
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true });
  } catch {
    return "";
  }
}
